import * as React from 'react';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { defaultPageable, Pageable } from '../../api/pageable';
import EmptyPage from '../../components/emptyPage/EmptyPage';
import { translation } from '../../i18n';
import { RouteComponentProps, withRouter } from 'react-router';
import { EVALUATION_ROUTE } from '../../router/routes';
import { getAllQuestionnairesForEvaluation } from '../assessment/questionnaireApi';
import AnsweredQuestionnaireList from '../../components/questionnaire/answeredQuestionnaire/AnsweredQuestionnaireList';
import { withAnsweredQuestionnairePage } from '../../router/Loaders';
import { AnsweredQuestionnaireDto } from '../answeredQuestionnaireTypes';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
}

type CombinedProps = RouteComponentProps & Props;

@observer
class EvaluationList extends React.Component<CombinedProps, {}> {

  @observable private pageAble: Pageable = defaultPageable();

  constructor(props: CombinedProps) {
    super(props);
    this.props.renderSearch(true);
  }

  public render() {
    return (
      <>
        {
          withAnsweredQuestionnairePage(
            () => getAllQuestionnairesForEvaluation({searchText: this.props.searchText.get()}, this.pageAble),
            'withAnsweredPage' + this.pageAble.page + this.props.searchText,
            answeredQuestionnairePage =>
              <AnsweredQuestionnaireList
                downloadButtonEnabled={true}
                questionnaires={answeredQuestionnairePage}
                handleChangePage={this.handleChangePage}
                onClick={(questionnaireDto: AnsweredQuestionnaireDto) =>
                  this.props.history.push(EVALUATION_ROUTE.evaluation(questionnaireDto.id).route)}
                emptyPage={
                  <EmptyPage message={translation.t('noEntry.evaluation.title')}
                             searchText={this.props.searchText.get()}
                             displayFab={false}
                  />
                }
              />
          )
        }
      </>
    );
  }

  private handleChangePage = (event: any, page: number) => {
    this.pageAble.page = page;
  };
}

export default withRouter(EvaluationList);
